export function getCdnUrl(): string {
  return import.meta.env.VITE_CDN_URL;
}
